import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRedirect, browserHistory } from 'react-router';
import { Provider } from 'react-redux';

import configureStore from './store/configureStore';
import { setLoggedIn } from './actions/environment';
import { URL, APP_SITE_URL } from './constants';
import App from './containers/App';
import BookingContainer from './containers/BookingContainer';
import CalendarContainer from './containers/CalendarContainer';
import CreateStepperContainer from './containers/CreateStepperContainer';
import Loading from './components/Loading';

import * as navigate from './services/navigate';

import './main.css';

const store = configureStore();

const handleLogin = (nextState, replace) => {
    store.dispatch(setLoggedIn(true));
    replace(`/loading`);
};

const routeChange = (prevState, nextState, replace) => {
    if (process.env.ANALYTICS) {
        analytics.page(`User navigated between pages`, {
            previousPage: prevState.location,
            currentPage: nextState.location,
        });
    }
};

ReactDOM.render(
    <Provider store={store}>
        <Router history={browserHistory}>
            <Route path="/" component={App} onChange={routeChange}>
                <IndexRedirect to="/loading" />
                <Route path="/loggedin" onEnter={handleLogin} />
                <Route path="/loading" component={Loading} />
                <Route path="/bookings" component={CalendarContainer} />
                <Route path="/bookings/create" component={CreateStepperContainer} />
                <Route path="/bookings/:staticUId" component={BookingContainer} />
                <Route path="*" component={BookingContainer} />
            </Route>
        </Router>
    </Provider>,
    document.getElementById(`main`)
);



// WEBPACK FOOTER //
// ./scripts/main.js